export const STATUSES = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  FULFILLED: 'FULFILLED',
  REJECTED: 'REJECTED',
} as const;

export type Status = typeof STATUSES[keyof typeof STATUSES];
